import { FancyInput } from 'components/ui/Inputs';
import React from 'react';
import { setRequestNumber } from 'redux/services/twittlebugs/sparingParams';
import { useAppDispatch } from 'redux/store';
import { useDebouncedCallback } from 'use-debounce';

export const OrderNameFilter = (): JSX.Element => {
  /* ******************** Hooks ******************** */
  const dispatch = useAppDispatch();

  /* ******************** Functions ******************** */
  const handleChange = useDebouncedCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;

    dispatch(setRequestNumber(value || undefined));
  }, 500);

  return <FancyInput placeholder="Request ID | Name" onChange={handleChange} allowClear />;
};
